import { normalizeSearchString } from './normalizeSearchString'

export const isSearchQueryMatchForNameOrCountry = (
  bankName: string,
  bankCountry: string,
  searchQuery: string,
): boolean => {
  const query = normalizeSearchString(searchQuery)
  const name = normalizeSearchString(bankName)
  const countryName = normalizeSearchString(bankCountry)

  return name.includes(query) || countryName.includes(query)
}
